export const dict = {
  bookType: {
    //文書類型
    1: "判决书",
    2: "调解书",
    5: "撤诉裁定",
    3: "其他裁定",
  },
  istatus: {
    //
    1: "待审核",
    2: "生效",
    3: "驳回",
  },
  source: {
    1: "立案材料",
    2: "补充材料",
    3: "接收材料",
    5: "律师函",
  },
  auction_step: {
    1: "一拍",
    2: "二拍",
    3: "变卖",
  },
  auction_status: {
    1: "即将开始",
    2: "扣押中",
    3: "拍卖中",
    4: "已拍卖",
    5: "流拍",
  },
  item_type: {
    1: "车辆",
    2: "房产",
    3: "其他",
  },
};
